import { Switch } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceSwitch",
  // extends: Switch,
  mixins: [Switch, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    switchDisabled() {
      return this.disabled || (this.elForm || {}).disabled || this.isOperationDisabled() || !this.isAuth;
    },
  },
};
